import { BaseModal } from 'components/Toolkit/Modal/BaseModal';
import { UpsellCard } from 'components/Toolkit/UpsellCard/UpsellCard';

import { useUserContext } from 'contexts/UserContext';
import { useBoostModal } from 'components/Toolkit/BoostModal/hooks/useBoostModal';

import type { BoostModalProps } from 'components/Toolkit/BoostModal/types';

import * as Styles from 'components/Toolkit/BoostModal/styles';

function BoostModal({
  isOpen,
  askToClose,
  boostInfoList,
  baseUrl,
  cdnUrl,
  adId,
  displaySuggestedProductModal = false,
  bumpEligible = false,
  spotlightEligible = false,
  section,
  handleSelect,
  pageType,
}: BoostModalProps) {
  const { user } = useUserContext();
  const { handleClose } = useBoostModal({
    isOpen,
    askToClose,
    baseUrl,
    adId,
    displaySuggestedProductModal,
    bumpEligible,
    spotlightEligible,
    section,
    pageType,
    userId: user?.id,
  });

  return (
    <BaseModal
      isOpen={isOpen}
      askToClose={handleClose}
      testId="boost-modal"
      variant="WIDE"
    >
      <Styles.Header
        illustration={`${cdnUrl}/images/illustrations/boost-ad.svg`}
        title="Boost your Ad"
        listItems={['Increase visibility on your ad']}
      />
      <Styles.CardsContainer>
        {boostInfoList &&
          boostInfoList.map(
            (item, index) =>
              item && (
                <Styles.Card key={index} count={boostInfoList.length || 0}>
                  <UpsellCard
                    key={index}
                    dataTestId={item.type}
                    title={item.title}
                    lines={item.sellingPoints}
                    price={item.price}
                    ctaText="Choose"
                    onCta={() => handleSelect && handleSelect(item.id)}
                    selected={false}
                    variant="WIDE"
                    strength={item.viewsCount}
                    arrayLength={5}
                    ctaAttribute={
                      displaySuggestedProductModal ? 'button' : 'link'
                    }
                  />
                </Styles.Card>
              ),
          )}
      </Styles.CardsContainer>
    </BaseModal>
  );
}

export { BoostModal };
